import fp from 'lodash/fp';
import React, { useCallback } from 'react';
import { messaging } from '@factorin/container.macro';

import { Text, Button } from 'Modules/ui';
import { useAction } from 'Modules/core/redux';
import { useTranslation } from 'Modules/core/i18n';
import { messagingActions } from 'Modules/core/messaging';


export const CryptoProfileButton = ({ className, hide }) => {
    const { t } = useTranslation('profileButtons');

    const showCryptoProfilesModal = useAction(
        () => messagingActions.showModal({
            type: fp.has('CoCryptoProfilesModal', messaging.modalTypes)
                ? 'CoCryptoProfilesModal'
                : 'ReadOnlyCryptoProfilesManager',
        }),
    );
    const showModalWithClosePopup = useCallback(
        () => {
            showCryptoProfilesModal();
            hide();
        },
        [hide, showCryptoProfilesModal],
    );

    return (
        <Text
            component={Button}
            variant='auxiliary'
            className={className}
            onClick={showModalWithClosePopup}
        >
            {t('cryptoProfileButton')}
        </Text>
    );
};
